import React from 'react';

/**
 * example.js ProcessCard - 정산 프로세스 카드
 */
function ProcessCard({ label, amount, count, color, status }) {
  return (
    <div className="bg-white p-5 rounded-2xl border border-[#e0e0e0] shadow-md hover:shadow-lg transition-all flex-1">
      <div className="flex items-center justify-between mb-4">
        <span className="text-[18px] font-bold text-[#8b95a1]">{label}</span>
        <div className="w-2 h-2 rounded-full animate-pulse" style={{ backgroundColor: color }} />
      </div>
      <div className="">
        <span className="block text-[22px] font-black text-[#191f28]">{amount}</span>
        <span className="text-[16px] font-bold text-[#4e5968]">{count}</span>
      </div>
      {/* <div
        className="inline-flex px-3 py-1 rounded-lg text-[16px] font-black"
        style={{ backgroundColor: `${color}10`, color }}
      >
        {status}
      </div> */}
    </div>
  );
}

export default ProcessCard;
